import ReferralsMetrics from 'components/molecules/ReferralsMetrics/ReferralsMetrics';
import PageHeader from 'components/molecules/PageHeader/PageHeader';
import LifetimeReferralsStats from 'components/organisms/LifetimeReferralsStats/LifetimeReferralsStats.qmee';
import ReferAFriend from 'components/organisms/ReferAFriend/ReferAFriend.qmee';
import { ReferralsQmeeQuery } from 'components/pages/Referrals/__generated__/ReferralsQmeeQuery.graphql';
import { MORE } from 'components/pages/pages';
import React, { useState } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import classes from './Referrals.qmee.module.scss';

export type Props = {};

export default function Referrals({}: Props) {
  const data = useLazyLoadQuery<ReferralsQmeeQuery>(
    graphql`
      query ReferralsQmeeQuery {
        referralHistory {
          ...ReferralsMetrics_referralsRef
          ...LifetimeReferralsStats_referralsRef_qmee
        }
        walletBalance {
          amount {
            currency
          }
        }
        ...ReferAFriend_referralsRef_qmee
      }
    `,
    {},
    { fetchPolicy: 'store-and-network' },
  );

  const [showMetrics, setShowMetrics] = useState(false);
  const walletCurrency = data.walletBalance?.amount.currency;

  return (
    <div className={classes.root}>
      <PageHeader title="Refer a Friend" backHref={MORE.path} />
      <LifetimeReferralsStats referralsRef={data.referralHistory} walletCurrency={walletCurrency} />
      <ReferAFriend
        referralsRef={data}
        walletCurrency={walletCurrency}
        className={classes.referAFriend}
        onOpenMetrics={(e) => {
          e.preventDefault();
          setShowMetrics(true);
        }}
      />
      {showMetrics && (
        <ReferralsMetrics
          referralsRef={data.referralHistory}
          onClose={() => setShowMetrics(false)}
        />
      )}
    </div>
  );
}
